__turbopack_context__.v({
  "className": "montserrat_698baff2-module__64bPvq__className",
});
